import { render, staticRenderFns } from "./ShareGroupModal.vue?vue&type=template&id=1ba0d395&scoped=true&"
import script from "./ShareGroupModal.vue?vue&type=script&lang=js&"
export * from "./ShareGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareGroupModal.vue?vue&type=style&index=0&id=1ba0d395&scoped=true&lang=scss&"
import style1 from "./ShareGroupModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba0d395",
  null
  
)

export default component.exports